<template>
  <button
    class="flex items-center justify-center w-8 px-1 h-full overflow-hidden shrink-0 ring-inset"
    :aria-label="$i18n.locale"
    type="button"
    @click="openCountryBar"
    :title="$t('localeBar.title')"
  >
    <img class="inline-block w-auto h-full" :src="`/flags/${currentLocale}.svg`" :alt="currentLocale" />
  </button>
</template>

<script>
import { Bus } from '@/utils/bus';

export default defineNuxtComponent({
  computed: {
    currentLocale() {
      const { locale } = this.$i18n;

      if (locale === 'ch-fr' || locale === 'ch-de') {
        return 'ch';
      }

      if (locale === 'en') {
        return 'eu';
      }

      return locale;
    },
  },

  methods: {
    openCountryBar() {
      Bus.emit('openCountryBar');
    },
  },
});
</script>
